import { Box, Divider, Grid, IconButton, InputAdornment, TextField, Tooltip, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../../app-context';
import IForm from '../../../components/i-form/i-form.component';
import { getPOJOById, savePOJO } from '../order.services';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { formatTo0Decimal, isChecking, isEmpty, isNotEmpty, isNotNull, isPacking } from '../../common/util.services';
import IGridComponent from '../../../components/grid/i-grid.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import { GET_ALL_SUPPLIER_URL, TYPE_LABOR, TYPE_MATERIAL, TYPE_PROCESS } from '../../common/constants';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import IDateField from '../../../components/text-component/i-datefield/i-datefield.component';
import dayjs from 'dayjs';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import SpecsComponent from '../../master-data/specs/specs.component';
import { getMasterDataById } from '../../master-data/masterdata.services';
import INumberField from '../../../components/text-component/numberfield/i-numberfield.component';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import { Visibility } from '@mui/icons-material';
import HelpIcon from '@mui/icons-material/Help';
import { LABOR_SPECS_MAP, MATERIAL_SPECS_MAP, PROCESS_SPECS_MAP, SpecListItem } from '../../master-data/specs/specs.mapping';

const POJOForm = (props: any) => {
  const [title, setTitle] = useState<string>('');
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const params = useParams()
  const rows: GridRowsProp = [];
  const [pojoDetail, setPOJODetail] = useState(rows);
  const address = '40-D, Periyar Nagar 2nd Cross, Sengunthapuram PO, Karur - 639002, Tamil Nadu, India';
  const [pojoData, setPOJOData] = useState<any>({});
  const pojoId = params.pojoId;
  const [specList, setSpecList] = useState<any>([]);
  const [loader, setLoader] = useState(true);
  const {state} = useLocation();
  const [pojoType, setPOJOType] = useState('');
  const [specsData, setSpecsData] = useState(null);
  const [openSpecs, setOpenSpecs] = useState(false);
  const [cost, setCost] = useState(0);
  const [changeInput, setChangeInput] = useState(false);
  const [unitCostInput, setUnitCostInput] = useState(0);
  const [loading, setLoading] = useState(false);
  const [outputQuantity, setOutputQuantity] = useState(0);
  const [plannedOutput, setPlannedOutput] = useState(0);
  const {inputs, type, orderId, supplier, inputType, inputName, product, inputId, output, 
         orderCode, outputUom, challan, linkId, inputCode, consumption, unitCost, orderDate,
         outputQty, completedQty, outputDesc, productId, processLoss, pack, costingId} = state;

  const columns: GridColDef[] = [
    { 
      field: 'inputCode', headerName: 'Input Code', filterable: false, sortable: false, editable: false, width: 280,
      renderCell: (params) => { return <div className={'NA' === params.row.inputCode ? "" : "cell-link"}
      onClick={() => { openSpecsPopup(params.row.inputCode, params.row.inputId) }}>{params.row.inputCode}</div>}
    },
    { 
      field: 'inputDesc', headerName: 'Input Description', filterable: false, sortable: false, editable: false, width: 350,
    },
    { 
      field: 'inputQuantity', headerName: 'Required Input Qty', filterable: false, sortable: false, editable: false, width: 300,
      renderCell: (params: any) => 'NA' === params.row.inputCode ? 'NA' : 
                                   formatTo0Decimal(params.row.inputQuantity) + ' ' + params.row.inputUom
    },
    {
      field: 'plannedInput', headerName: 'Planned Input Qty', filterable: false, sortable: false, editable: false, width: 300,
      renderCell: (params: any) => 'NA' === params.row.inputCode ? 'NA' :
                                   isEmpty(params.row.plannedInput) ? '' : 
                                   formatTo0Decimal(params.row.plannedInput) + ' ' + params.row.inputUom
    },
    { 
      field: 'isPrint', headerName: 'Print', filterable: false, sortable: false, editable: true, width: 150, type: 'boolean'
    },
  ];
  
  function setSpecs(type: any, input: any) {
    if (type === TYPE_MATERIAL) {
      setSpecList(MATERIAL_SPECS_MAP[input]);
    } else if (type === TYPE_PROCESS) {
      setSpecList(PROCESS_SPECS_MAP[input]);
    } else if (type === TYPE_LABOR) {
      if(isChecking(input)) {
        setSpecList(LABOR_SPECS_MAP['Checking']);
      } else if(isPacking(input)) {
        setSpecList(LABOR_SPECS_MAP['Packing']);
      } else {
        setSpecList(LABOR_SPECS_MAP['Bale Packing']);
      }
    }
  };

  useEffect(() => {
    if(isNotNull(pojoId)) {
      getPOJOById(pojoId, appContext,
      (response: any) => {
        response.data.pack = 0 === response.data.pack ? 'NA' : response.data.pack;
        response.data.deliveryDate = dayjs(response.data.deliveryDate);
        response.data.poDate = dayjs(response.data.poDate);
        setOutputQuantity(response.data.outputQuantity);
        response.data.outputQuantity = formatTo0Decimal(response.data.outputQuantity) + ' (' + response.data.completedQty + ' already planned)';
        setTitle('Edit ' + response.data.pojoType);
        setPlannedOutput(response.data.plannedOutput);
        setUnitCostInput(response.data.unitCost);
        setPOJOType(response.data.pojoType);
        setPOJOData(response.data);
        setChangeInput(isNotEmpty(response.data.printUom));
        setSpecs(response.data.inputType, response.data.inputName);
        setPOJODetail(response.data.pojoDetail);
        setLoader(false);
        appContext.setShowLoader(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        setLoader(false);
      });
    } else {
      getMasterDataById(inputId, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        pojoData.description = response.data.description;
        pojoData.spec1 = response.data.spec1;
        pojoData.spec2 = response.data.spec2;
        pojoData.spec3 = response.data.spec3;
        pojoData.spec4 = response.data.spec4;
        pojoData.spec5 = response.data.spec5;
        pojoData.spec6 = response.data.spec6;
        pojoData.spec7 = response.data.spec7;
        pojoData.spec8 = response.data.spec8;
        pojoData.spec9 = response.data.spec9;
        pojoData.spec10 = response.data.spec10;
        pojoData.spec11 = response.data.spec11;
        pojoData.spec12 = response.data.spec12;
        pojoData.spec13 = response.data.spec13;
        pojoData.spec14 = response.data.spec14;
        pojoData.spec15 = response.data.spec15;
        pojoData.cgst = 2.5;
        pojoData.sgst = 2.5;
        pojoData.paymentMode = 'Online';
        pojoData.transportMode = 'Road';
        pojoData.destination = 'Karur';
        pojoData.reference = orderCode;
        setTitle('Create ' + type);
        setPOJOType(type);
        setPOJODetail(inputs);
        setUnitCostInput(unitCost);
        pojoData.output = output;
        pojoData.consumption = consumption;
        pojoData.product = product;
        pojoData.inputType = inputType;
        pojoData.inputName = inputName;
        pojoData.orderId = orderId;
        pojoData.supplier = supplier;
        pojoData.supplier2 = supplier;
        pojoData.deliveryAddress = address;
        pojoData.deliveryDate = dayjs();
        pojoData.poDate = dayjs();
        pojoData.inputId = inputId;
        pojoData.linkId = linkId;
        pojoData.inputCode = inputCode;
        pojoData.unitCost = unitCost;
        pojoData.outputDesc = outputDesc;
        pojoData.outputUom = outputUom;
        pojoData.pack = 0 === pack ? 'NA' : pack;
        pojoData.processLoss = processLoss;
        pojoData.consumption = consumption;
        pojoData.outputQuantity = formatTo0Decimal(outputQty) + ' (' + completedQty + ' already planned)';
        pojoData.orderCode = orderCode;
        pojoData.orderDate = dayjs(orderDate);
        pojoData.productId = productId;
        pojoData.costingId = costingId;
        setSpecs(inputType, inputName);
        setOutputQuantity(outputQty);
        appContext.setShowLoader(false);
        setLoading(false);
        setLoader(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
    }
  }, []);

  useEffect(() => {
    calculateCost();
  }, [unitCostInput, plannedOutput]);

  const openSpecsPopup = (inputCode: any, inputId: any) => {
    if('NA' !== inputCode) {
      setLoading(true);
      getMasterDataById(inputId, appContext,
        (response: any) => {
          appContext.setShowLoader(false);
          setLoading(false);
          setSpecsData(response.data);
          setOpenSpecs(true);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  };

  const closeSpecs = () => {
    setOpenSpecs(false);
  }

  function calculateCost() {
    let cost = 0;
    for(let i = 0; i < pojoDetail.length; ++i) {
      let detail = pojoDetail[i];
      detail.plannedInput = (+plannedOutput / +outputQuantity) * +detail.inputQuantity;
    }
    cost = pojoData.consumption * plannedOutput * unitCostInput/pojoData.output;
    setCost(cost);
  }

  function validateDetails() {
    let printCount = 0;
    for(let i = 0; i < pojoDetail.length; ++i) {
      let detail = pojoDetail[i];
      if((isEmpty(detail.plannedInput) && 'NA' !== detail.inputCode) || isEmpty(detail.inputUom)) {
        appContext.setDialogMessage('Enter Input UOM and Planned Input.');
        return false;
      }

      if(Math.round(detail.plannedInput) > Math.round(detail.inputQuantity)) {
        /*appContext.setDialogMessage('Planned Input cannot be more than Required Input.');
        return false;*/
      }
      if(detail.isPrint) {
        ++printCount;
      }
    }
    if('Purchase Order' !== pojoType) {
      if(printCount > 1) {
        appContext.setDialogMessage('Select only one input to include in printing.');
        return false;
      } else if(printCount < 1) {
        appContext.setDialogMessage('Select an input to include in printing.');
        return false;
      }
    }

    return true;
  }

  const processRowUpdate = (updatedRow: any, originalRow: any) => {
    pojoDetail[updatedRow.serial - 1].isPrint = updatedRow.isPrint ? 1 : 0;
  }

  const onSubmit = (data: any) => {
    if(!validateDetails()) {
      return;
    }

    let today = dayjs(dayjs().format('YYYY-MM-DD'));
    let ordDate = dayjs(dayjs(data.orderDate).format('YYYY-MM-DD'));
    let poDate = dayjs(dayjs(data.poDate).format('YYYY-MM-DD'));

    if(poDate.isAfter(today)) {
      appContext.setDialogMessage('Future PO/JS date is not allowed.');
      return;
    } else if(poDate.isBefore(ordDate)) {
      appContext.setDialogMessage('PO/JS date is before order date.');
      return;
    }

    if(data.deliveryTerm1.length > 80 || data.deliveryTerm2.length > 80 || data.deliveryTerm3.length > 80 ||
       data.deliveryTerm4.length > 80 || data.deliveryTerm5.length > 80) {
      appContext.setDialogMessage('Delivery terms can have max 80 characters.');
      return;
    }

    if(plannedOutput <= 0) {
      appContext.setDialogMessage('Planned output should be greater than 0.');
      return;
    }

    data.pojoDetail = pojoDetail;
    data.pojoType = pojoType;
    data.outputQuantity = outputQuantity;
    data.plannedOutput = plannedOutput;
    data.cost = cost;
    data.pack = 'NA' === data.pack ? 0 : data.pack;
    if(!changeInput) {
      data.printQuantity = null;
      data.printUom = null;
      data.printUnitCost = null;
      data.printCurrency = null;
    }
    savePOJO(data, appContext,
      (response: any) => {
        if(isNotEmpty(challan) && 'NA' !== challan) {
          appContext.setDialogMessage('The PO/JS has a challan. Supplier and unit cost were not updated.');
        }
        navigate(-1);
        appContext.setSuccessMessage(response.message)
        appContext.setShowLoader(false);
      }, (error: any) => {
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message)
      });
  }

  function getDeliveryTerms() {
    let array: any = [];

    array[0] = '- Payment term - XX days from the actual delivery date';
    array[1] = '- Quality should be as per the approved sample or bit loom';
    array[2] = '- Transport cost is extra';
    array[3] = '- Piece length should be at least XX';
    array[4] = '- Initial XX units will be checked by LFH Home';
    array[5] = '- Goods to be delivered at XX location';

    let newText = array.map((i: any, index: any) => { 
      return <p key={index} style={{ margin: '4px 0' }}>{i}</p> 
    });

    return newText;
  }

  const openSpecsPage = () => {
    openSpecsPopup(pojoData.inputCode, pojoData.inputId);
  };

  const changeInputValue = () => {
    setChangeInput(changeInput ? false : true);
  };

  const getMainComponent = () => {
    const popperProps = {sx: {'.MuiTooltip-tooltip': {bgcolor: 'ivory', fontSize: 16, color: 'black', border: 1}}};
    return <Grid container spacing={1}>
      <Grid xs={2}>
        <ITextField name='pojoCode' label='Code' required={false} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='product' label='Product' required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='inputType' label='Input Type' required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='inputName' label='Input Name' required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='inputCode' label={'Input Code'} required={true} disabled={true}
          InputProps={{startAdornment: (<InputAdornment position="start"> 
                      <IconButton onClick={openSpecsPage} edge="start">
                      <Visibility fontSize='small' color='secondary'/></IconButton> </InputAdornment>)}}/>
      </Grid>
      {'Purchase Order' === pojoType && <Grid xs={'Purchase Order' === pojoType ? 1 : 2}>
        <ITextField name='hsnCode' label='HSN Code' required={true}/>
      </Grid>}
      <Grid xs={'Purchase Order' === pojoType ? 1 : 2}>
        <INumberField name='unitCost' label={'Unit Cost'} required={true} disabled={false}
          onActionEvent={(e: any) => {setUnitCostInput(e.target.value)}}/>
      </Grid>
      <Grid xs={2}>
        <INumberField name='processLoss' label={'Process Loss (%)'} required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='outputDesc' label={'Output Description'} required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='outputUom' label={'Output UOM'} required={true} disabled={true}
          InputProps={{endAdornment: (<InputAdornment position="end">
                      <Tooltip title={'Change print output details'} PopperProps={popperProps}>
                      <IconButton onClick={changeInputValue} edge="end">
                      <ChangeCircleIcon fontSize='small' color='secondary'/></IconButton></Tooltip></InputAdornment>)}}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='pack' label={'Pc/Pack'} required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <ITextField name='outputQuantity' label={'Required Output'} required={true} disabled={true}/>
      </Grid>
      <Grid xs={2}>
        <INumberField name='plannedOutput' label={'Planned Output'} required={true} disabled={false}
          onActionEvent={(e: any) => {setPlannedOutput(e.target.value)}} />
      </Grid>
      <Grid xs={2}>
        <TextField name='cost' label={'Purchase Order' === pojoType ? 'Material Cost' : 'Process Cost'} 
          required={true} disabled={true} value={formatTo0Decimal(cost)} margin='dense' inputProps={{ style: { height: "9px"}}}/>
      </Grid>
      <Grid xs={1.33}>
        <INumberField name='cgst' label='CGST'/>
      </Grid>
      <Grid xs={1.33}>
        <INumberField name='sgst' label='SGST'/>
      </Grid>
      <Grid xs={1.34}>
        <INumberField name='igst' label='IGST'/>
      </Grid>
      <Grid xs={2}>
        <IDropdown name='supplier' label='Supplier' required={true} url={GET_ALL_SUPPLIER_URL} disabled={false}/>
      </Grid>
       <Grid xs={2}>
        <IDateField name='poDate' label= {'Purchase Order' === pojoType ? 'PO Date' : 'JO Date'} required={true} disabled={false}/>
      </Grid>
      <Grid xs={2}>
        <IDateField name='deliveryDate' label='Delivery Date' required={true} disabled={false}/>
      </Grid>
      <Box sx={{ width: '98.5%', marginLeft: 1.35, marginTop: 2}}>
        <Divider>
          <Typography sx={{fontSize: 14, fontWeight: 'bold'}}>Print Data</Typography>
        </Divider>
        <Grid container spacing={1} sx={{marginTop: 1}}>
          <Grid xs={1.5}>
            <IDropdown name='paymentMode' label='Payment Mode' itemList={['Online', 'Cheque/DD', 'Cash']} required={true}/>
          </Grid>
          <Grid xs={1.5}>
            <ITextField name='reference' label='Reference' required={true}/>
          </Grid>
          <Grid xs={1.5}>
            <IDropdown name='transportMode' label='Transport Mode' itemList={['Air', 'Courier', 'Ocean', 'Road', 'Train']} required={true}/>
          </Grid>
          <Grid xs={1.5}>
            <ITextField name='destination' label='Destination' required={true}/>
          </Grid>
          <Grid xs={1.5}>
            <ITextField name='description' label='Description' required={true}/>
          </Grid>
          {specList.map((spec: SpecListItem) => {
            return <Grid xs={1.5}> <ITextField name={spec.fieldObject} label={spec.fieldName} 
                                  disabled={'spec14' === spec.fieldObject || 
                                  ('GSM' === spec.fieldName && 'Fabric' === pojoData.inputName)} />
                   </Grid>})}
          <Grid xs={'Fabric' === pojoData.inputName ? 3 : 3.5}>
            <ITextField name='deliveryTerm1' label='Delivery Term 1'
              InputProps={{endAdornment: (<InputAdornment position="end">
                        <Tooltip title={getDeliveryTerms()} PopperProps={popperProps}
                        slotProps={{ tooltip: { sx: { maxWidth: 600, width: '100%' }}}}>
                        <IconButton edge="end"> <HelpIcon fontSize='small' color='secondary'/>
                        </IconButton></Tooltip></InputAdornment>)}}/>
          </Grid>
          <Grid xs={'Fabric' === pojoData.inputName ? 3 : 3.5}>
            <ITextField name='deliveryTerm2' label='Delivery Term 2'/>
          </Grid>
          <Grid xs={'Fabric' === pojoData.inputName ? 4 : 3.5}>
            <ITextField name='deliveryTerm3' label='Delivery Term 3'/>
          </Grid>
          <Grid xs={'Fabric' === pojoData.inputName ? 4 : 6}>
            <ITextField name='deliveryTerm4' label='Delivery Term 4'/>
          </Grid>
          <Grid xs={'Fabric' === pojoData.inputName ? 4 : 6}>
            <ITextField name='deliveryTerm5' label='Delivery Term 5'/>
          </Grid>
          {changeInput && <Grid xs={3}>
            <INumberField name='printQuantity' label='Quantity' required={true}/>
          </Grid>}
          {changeInput && <Grid xs={3}>
            <ITextField name='printUom' label='UOM' required={true}/>
          </Grid>}
          {changeInput && <Grid xs={3}>
            <INumberField name='printUnitCost' label='Unit Cost' required={true}/>
          </Grid>}
          {changeInput && <Grid xs={3}>
            <IDropdown name='printCurrency' label='Currency'  required={true} itemList={['Rs.', '$', '€', '£', '¥']}/>
          </Grid>}
        </Grid>
      </Box>
      {'Purchase Order' !== pojoType && <Grid container spacing={0}>
        <IGridComponent title={'Input Details'} rows={pojoDetail} columns={columns} getRowId={(row: any) => row.serial} maxHeight={"60vh"}
          apiRef={props.apiRef} showAction={false} showAddBtn={false} hideFooter={true} hideFooterPagination={true} 
          loading={loading} processRowUpdate={processRowUpdate}/> </Grid>}
      <Grid>
        <IDialogComponent onClose={closeSpecs} open={openSpecs} title='Specifications' dialogClass={'spec-panel'} 
          dialogBody={<SpecsComponent data={specsData} />} />
      </Grid>
    </Grid>
  }

  return loader ? <></> : <IForm formData={pojoData} title={title} submitForm={onSubmit} mainComponent={getMainComponent()}></IForm>
}

export default POJOForm;